module.exports = __webpack_public_path__ + "img/blob_3.4c1c599c.svg";